import { getDiffArray, getArrayNumberChanges } from './chunk-X6IVGVL4.mjs';
import { selectChangeDataId, selectReportingGroups, selectItems, selectCombos, selectCurrentItem } from './chunk-RO5AAHK3.mjs';
import { REPORTING_GROUP_INITIAL_STATE } from './chunk-6BKQGMKT.mjs';
import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/menuDifferences/diffReportingGroupFactory.ts
var ReportingGroupFieldLabels = /* @__PURE__ */ ((ReportingGroupFieldLabels2) => {
  ReportingGroupFieldLabels2[ReportingGroupFieldLabels2["name"] = 0] = "name";
  ReportingGroupFieldLabels2[ReportingGroupFieldLabels2["active"] = 1] = "active";
  return ReportingGroupFieldLabels2;
})(ReportingGroupFieldLabels || {});
var returnLabel = (field) => {
  if (field in ReportingGroupFieldLabels) {
    return i18n_config_default.t(
      `app.modals.reportingGroupsDiff.changes.${field}`
    );
  }
};
var diffReportingGroupFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const reportingGroupId = selectChangeDataId(state);
    const reportingGroups = selectReportingGroups(state);
    const items = selectItems(state);
    const combos = selectCombos(state);
    const originalData = reportingGroupId ? reportingGroups[reportingGroupId] : REPORTING_GROUP_INITIAL_STATE;
    const changeData = selectCurrentItem(state);
    const basicChanges = getDiffArray(
      diffArray,
      returnLabel,
      ReportingGroupFieldLabels,
      1
    );
    const associationsChanges = [];
    const itemIdsChanges = getArrayNumberChanges(
      originalData.itemIds,
      changeData.itemIds
    );
    const comboIdsChanges = getArrayNumberChanges(
      originalData.comboIds,
      changeData.comboIds
    );
    if (itemIdsChanges.length > 0) {
      associationsChanges.push({
        field: "itemIds",
        label: i18n_config_default.t("app.modals.reportingGroupsDiff.changes.itemIds"),
        value: itemIdsChanges.map((change) => __spreadProps(__spreadValues({}, change), {
          value: items[change.id].name
        }))
      });
    }
    if (comboIdsChanges.length > 0) {
      associationsChanges.push({
        field: "comboIds",
        label: i18n_config_default.t("app.modals.reportingGroupsDiff.changes.comboIds"),
        value: comboIdsChanges.map((change) => __spreadProps(__spreadValues({}, change), {
          value: combos[change.id].name
        }))
      });
    }
    return {
      basic: basicChanges,
      associations: associationsChanges
    };
  }
  return null;
};

export { ReportingGroupFieldLabels, diffReportingGroupFactory };
